var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.article ? _c('div', [_c('Banner', {
    attrs: {
      "page": _vm.article
    }
  }), _c('section', {
    staticClass: "profile events-page-wrap clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 kothing-editor-editable",
    staticStyle: {
      "background-color": "transparent !important"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.article.title))]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  })])])])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }